export const privacyList = [
    { block: 'block1'},
    { block: 'block2'},
    { block: 'block3'},
    { block: 'block4'},
    { block: 'block5'},
    { block: 'block6'},
    { block: 'block7'},
    { block: 'block8'},
    { block: 'block9'},
    { block: 'block10'},
    { block: 'block11'},
    { block: 'block12'},
    { block: 'block13'},
];